import { render } from "./NotesCaption.vue?vue&type=template&id=763da0df&scoped=true"
import script from "./NotesCaption.vue?vue&type=script&lang=js"
export * from "./NotesCaption.vue?vue&type=script&lang=js"

import "./NotesCaption.vue?vue&type=style&index=0&id=763da0df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763da0df"]])

export default __exports__